import { createContext } from "react";

export const ObjectiveDetailContext = createContext();
